import React, { useState } from "react";
import { Button as RadixButton } from "@radix-ui/themes";
import { Message } from "ai";

import { Converter } from "showdown";

import styles from "./styles.module.scss";

export const MessageComponent = ({
  m,
  index,
  handleBadFeedback,
}: {
  m: Message;
  index: number;
  handleBadFeedback: () => void;
}) => {
  const convertor = new Converter({
    simplifiedAutoLink: true,
    excludeTrailingPunctuationFromURLs: true,
    openLinksInNewWindow: true,
    smoothLivePreview: true,
    disableForced4SpacesIndentedSublists: true,
  });

  const convertMarkdownToHTML = (markdown: string) => {
    if (markdown) {
      // return markdown;
      return convertor?.makeHtml(markdown);
    } else {
      return "";
    }
  };

  const annotations = m.annotations?.[0] ?? m.annotations;

  const isRtl =
    ((annotations as any[])?.[(annotations as any[])?.length - 1] as any)
      ?.isRtl ?? false;

  const chosenTool =
    m.toolInvocations && m.toolInvocations?.length > 0
      ? m.toolInvocations[0].state === "result"
        ? m.toolInvocations[0].result.action === "talk_to_an_agent"
          ? "It's just a playground, but in real life I'd pass this conversation to an agent based on the escalation policy that you will set."
          : m.toolInvocations[0].result.action === "skip_it"
          ? "-- Im skipping this conversation due to low confidence -- you'd be able to train me and adjust the confidence level once we start working together."
          : null
        : null
      : null;

  return (
    <>
      {(m.content || chosenTool) && (
        <div
          className={`w-full flex ${m.role === "user" ? " justify-end" : " "}`}
        >
          <div
            className={`
         p-2 rounded-sm relative min-w-12 w-fit text-sm
        ${
          m.role === "user" ? ` bg-black text-white` : " bg-gray-200 text-black"
        }`}
          >
            {m.toolInvocations && m.toolInvocations?.length > 0 ? (
              <>{chosenTool}</>
            ) : (
              <div
                className={styles.message}
                dir={isRtl ? "rtl" : "ltr"}
                dangerouslySetInnerHTML={{
                  __html: convertMarkdownToHTML(m.content),
                }}
              />
            )}

            {m.role === "assistant" && index > 0 && (
              <div className=" absolute left-2 h-16 -bottom-6 items-end flex gap-4">
                <RadixButton
                  variant="ghost"
                  size="1"
                  color="gray"
                  highContrast
                  onClick={() => {
                    handleBadFeedback();
                  }}
                >
                  BAD RESPONSE!
                </RadixButton>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
